import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createAppRouter } from '@/router/index'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { vueQueryPluginOptions } from '@/plugins/vue-query'
import App from './App.vue'
import vueLenisPlugin from 'lenis/vue'

import i18n, { loadLocaleMessages, FALLBACK_LOCALE } from '@/plugins/i18n'
import versionPlugin from '@/plugins/version'
import 'virtual:svg-icons-register'
import { Quasar, QDate } from 'quasar'
import { useLocale } from '@/composables/useLocale'
import langTw from 'quasar/lang/zh-TW'
import langEn from 'quasar/lang/en-US' // 英文

// @ts-ignore
import VueDOMPurifyHTML from 'vue-dompurify-html'

// @ts-ignore
import VueResizeText from 'vue3-resize-text'

import 'ant-design-vue/dist/reset.css'
import '@/assets/normalize.css'
import 'vue-fast-marquee/style.css'
import 'lenis/dist/lenis.css'

const { router } = createAppRouter()
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(VueQueryPlugin, vueQueryPluginOptions)
app.use(router)
app.use(i18n)
app.use(versionPlugin)
app.use(VueDOMPurifyHTML)
app.use(VueResizeText)
app.use(vueLenisPlugin)
app.use(Quasar, {
  components: { QDate },
  lang: useLocale() === 'tw' ? langTw : langEn
})

app.config.warnHandler = () => null

// 不阻塞 mount：先啟動 i18n 載入，同時掛載應用
// vue-i18n 的 setLocaleMessage 是響應式的，訊息載入完成後 UI 自動更新
const locale = useLocale() ?? FALLBACK_LOCALE
loadLocaleMessages(locale)
app.mount('#app')
